'use client';

import { useTranslations } from 'next-intl';
import React, { FC, ReactNode } from 'react';
import { TriviaGameHome } from './trivia-game-home';
import { UnauthorizedPanel } from './unauthorized-panel';
import { useIsAuthenticated } from '@wwe-portal/web/providers/stores/auth-store';
import { ClientOnly } from '../common/client-only';
import { TriviaGameSkeleton } from './trivia-game-skeleton';
import { useGetUserInfo } from '@wwe-portal/web/providers/queries/user-info';
import Image from 'next/image';

export const TriviaGameLoginLayout: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const t = useTranslations();
  return (
    <>
      <div className="relative mb-11 rounded-[10px] py-[10px] text-center text-white md:py-[30px]">
        <Image
          src="/assets/images/trivia-rumble/trivia-rumble-title-bg.webp"
          alt="trivia-rumble-title-bg"
          fill
          className="absolute left-0 top-0 h-full w-full rounded-md object-cover object-center"
        />
        <div className="relative z-10">
          <p className="text-[20px] font-medium md:text-[28px]">
            {t('trivia_game_title')}
          </p>
          <span className="text-xs md:text-sm">
            {t('trivia_game_description')}
          </span>
        </div>
      </div>
      {children}
    </>
  );
};

function TriviaGameLoginContent() {
  const t = useTranslations();
  const isAuthenticated = useIsAuthenticated();
  const { isLoading } = useGetUserInfo();
  if (isLoading) {
    return (
      <TriviaGameLoginLayout>
        <TriviaGameSkeleton />
      </TriviaGameLoginLayout>
    );
  }

  return (
    <TriviaGameLoginLayout>
      <div className="changes-screen">
        <div className="changes-screen-anim">
          {isAuthenticated ? (
            <TriviaGameHome />
          ) : (
            <div className="trivia-rumble-game_login_panel mb-5 flex justify-center">
              <UnauthorizedPanel
                isLoggedIn={false}
                description={t('trivia_rumble_loggedIn_description')}
              />
            </div>
          )}
        </div>
      </div>
    </TriviaGameLoginLayout>
  );
}

export const TriviaGameLogin = () => {
  return (
    <ClientOnly
      placeholder={
        <TriviaGameLoginLayout>
          <TriviaGameSkeleton />
        </TriviaGameLoginLayout>
      }
    >
      <TriviaGameLoginContent />
    </ClientOnly>
  );
};
